import BaseApi from "./BaseApi";

class IncidentReportApi extends BaseApi {
  constructor() {
    super("incident-reports");
  }
}

export default IncidentReportApi;
